// Status color coding for draft (yellow) vs sent (green) records
export const STATUS_ROW_COLORS = {
  DRAFT: {
    background: '#FEF3C7', // Light yellow
    border: '#F59E0B', // Yellow border
  },
  PENDING: {
    background: '#FEF3C7', // Light yellow (same as draft for unsent)
    border: '#F59E0B',
  },
  SENT: {
    background: '#D1FAE5', // Light green
    border: '#10B981', // Green border
  },
  ACCEPTED: {
    background: '#D1FAE5', // Light green
    border: '#10B981',
  },
  DECLINED: {
    background: '#FEE2E2', // Light red
    border: '#EF4444',
  },
  NEW: {
    background: '#DBEAFE', // Light blue
    border: '#3B82F6',
  },
  IN_PROGRESS: {
    background: '#E0E7FF', // Light indigo
    border: '#6366F1',
  },
  COMPLETE: {
    background: '#D1FAE5', // Light green
    border: '#10B981',
  },
} as const

export type StatusKey = keyof typeof STATUS_ROW_COLORS

export function getStatusRowStyle(status: string): {
  backgroundColor: string
  borderLeft: string
} {
  const normalizedStatus = status?.toUpperCase() as StatusKey
  const colors =
    STATUS_ROW_COLORS[normalizedStatus] || STATUS_ROW_COLORS.PENDING
  return {
    backgroundColor: colors.background,
    borderLeft: `4px solid ${colors.border}`,
  }
}
